import {useState, useEffect, useRef} from 'react'

/**
 * Hook to calculate and expose the minHeight needed
 * for a grid of N rows × M columns, given the container’s width
 * and a constant grid-gap.
 */
export function useGridMinHeight({ columns = 7, rows = 6, gap = 4 }) {
  const ref = useRef(null)
  const [minHeight, setMinHeight] = useState(0)

  useEffect(() => {
    if (!ref.current) return

    function updateHeight() {
      const width = ref.current.offsetWidth
      // total horizontal space taken by gaps between columns:
      const totalHGap = gap * (columns - 1)
      // width of each “button” (square cell):
      const cell = (width - totalHGap) / columns
      // total vertical gap space between rows:
      const totalVGap = gap * (rows - 1)
      // overall height = rows × cell + total vertical gaps
      setMinHeight(Math.ceil(cell * rows + totalVGap))
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [columns, rows, gap])

  return [ref, minHeight]
}


export default useGridMinHeight